<template>
    <van-row class="prolist">
        <van-row class="protitle">
            <van-col span="12">{{ $t('index.hottitle') }}</van-col>
            <van-col span="12"></van-col>
        </van-row>
        <van-row class="list">
            <van-col span="24">
                <van-row>
                    <van-col span="24"></van-col>
                </van-row>
                <van-row>
                    <van-col span="24">
                        <van-tabs v-model="active">
                            <van-tab :title=" $t('index.weekrhot')">
                                <van-row class="tabcont" v-for="item in prolist.hot" :key="item.id">
                                    <router-link :to="`/Details?id=${item.id}`">
                                        <van-col span="24">
                                            <van-row>
                                                <van-col span="18" class="tab_tit">{{item.title}}</van-col>
                                                <van-col span="6"><van-tag round type="primary" color="#7232dd">{{item.tag}}</van-tag></van-col>
                                            </van-row>
                                            <van-row class="list_middle">
                                                <van-col span="7" class="rate">{{item.rate}}%</van-col>
                                                <van-col span="10"></van-col>
                                                <van-col span="7" class="buybtn"><van-button color="linear-gradient(to right, #ff6034, #ee0a24)" size="mini">{{ $t('index.buybtn') }}</van-button></van-col>
                                            </van-row>
                                            <van-row>
                                                <van-col span="7" class="row31">{{ $t('index.rate') }}</van-col>
                                                <van-col span="10"></van-col>
                                                <van-col span="7"></van-col>
                                            </van-row>
                                        </van-col>
                                    </router-link>
                                </van-row>
                            </van-tab>
                            <van-tab :title=" $t('index.yjtitle')">
                                <van-row class="tabcont" v-for="item in prolist.steady" :key="item.id">
                                    <router-link :to="`/Details?id=${item.id}`">
                                        <van-col span="24">
                                            <van-row>
                                                <van-col span="18" class="tab_tit">{{item.title}}</van-col>
                                                <van-col span="6"><van-tag round type="primary" color="#7232dd">{{item.tag}}</van-tag></van-col>
                                            </van-row>
                                            <van-row class="list_middle">
                                                <van-col span="7" class="rate">{{item.rate}}%</van-col>
                                                <van-col span="10"></van-col>
                                                <van-col span="7" class="buybtn"><van-button color="linear-gradient(to right, #ff6034, #ee0a24)" size="small">{{ $t('index.buybtn') }}</van-button></van-col>
                                            </van-row>
                                            <van-row>
                                                <van-col span="7">{{ $t('index.rate') }}</van-col>
                                                <van-col span="10"></van-col>
                                                <van-col span="7"></van-col>
                                            </van-row>
                                        </van-col>
                                    </router-link>
                                </van-row>
                            </van-tab>
                            <van-tab :title=" $t('index.dqtitle')">
                                <van-row class="tabcont" v-for="item in prolist.short" :key="item.id">
                                    <router-link :to="`/Details?id=${item.id}`">
                                        <van-col span="24">
                                            <van-row>
                                                <van-col span="18" class="tab_tit">{{item.title}}</van-col>
                                                <van-col span="6"><van-tag round type="primary" color="#7232dd">{{item.tag}}</van-tag></van-col>
                                            </van-row>
                                            <van-row class="list_middle">
                                                <van-col span="7" class="rate">{{item.rate}}%</van-col>
                                                <van-col span="10"></van-col>
                                                <van-col span="7" class="buybtn"><van-button color="linear-gradient(to right, #ff6034, #ee0a24)" size="small">{{ $t('index.buybtn') }}</van-button></van-col>
                                            </van-row>
                                            <van-row>
                                                <van-col span="7">{{ $t('index.rate') }}</van-col>
                                                <van-col span="10"></van-col>
                                                <van-col span="7"></van-col>
                                            </van-row>
                                        </van-col>
                                    </router-link>
                                </van-row>
                            </van-tab>
                            <van-tab :title=" $t('index.sytitle')">
                                <van-row class="tabcont" v-for="item in prolist.first" :key="item.id">
                                    <router-link :to="`/Deatils?id=${item.id}`">
                                        <van-col span="24">
                                            <van-row>
                                                <van-col span="18" class="tab_tit">{{item.title}}</van-col>
                                                <van-col span="6"><van-tag round type="primary" color="#7232dd">{{item.tag}}</van-tag></van-col>
                                            </van-row>
                                            <van-row class="list_middle">
                                                <van-col span="7" class="rate">{{item.rate}}%</van-col>
                                                <van-col span="10"></van-col>
                                                <van-col span="7" class="buybtn"><van-button color="linear-gradient(to right, #ff6034, #ee0a24)" size="mini">{{ $t('index.buybtn') }}</van-button></van-col>
                                            </van-row>
                                            <van-row>
                                                <van-col span="7">{{ $t('index.rate') }}</van-col>
                                                <van-col span="10"></van-col>
                                                <van-col span="7"></van-col>
                                            </van-row>
                                        </van-col>
                                    </router-link>
                                </van-row>
                            </van-tab>
                        </van-tabs>
                    </van-col>
                </van-row>
            </van-col>
        </van-row>
    </van-row>
</template>

<script>
    export default {
        name: "Prohot",
        data(){
            return{
                active: 0
            }
        },
        props:{
            prolist:{
                required:true
            }
        }
    }
</script>

<style scoped lang="scss">
    .prolist{
        overflow: hidden;
        min-height: 250px;
        width: 92%;
        margin: 0 auto 10px auto;
        padding-bottom: 10px;
        background: white;
        text-align: left;
        border-radius: 10px;
        .protitle{
            height: 50px;
            width: 100%;
            font-size: 18px;
            line-height: 50px;
            text-align: left;
            text-indent: 10px;
            color: #333;
            font-weight: bold;
            background: url("~@/assets/images/bg_group_suggest.png") no-repeat;
            background-size: 100% 100%;
        }
        .list{
            .tabcont{
                margin: 10px;
                padding-bottom: 12px;
                border-bottom: 1px solid #ccc;
                .tab_tit{
                    color: #666;
                    font-size: 14px;
                    font-weight: bold;
                }
                .list_middle{
                    height: 25px;
                    line-height: 25px;
                    width: 100%;
                    .rate{
                        height: 25px;
                        line-height: 25px;
                        color: red;
                        font-size: 16px;
                        font-weight: bold;

                    }
                    .buybtn{
                        text-align: right;
                    }
                }
                .row31{

                }
                a{
                    color: #666666;
                }

            }
        }
    }
</style>
